import React, { useState, useEffect, useCallback } from "react";

const DynamicTable2 = ({ tableName, columns, localStorageKey, onTableDataChange }) => {
  // Apply default value for disableFirstRow
  const updatedColumns = columns.map(col => ({
    ...col,
    disableFirstRow: col.disableFirstRow ?? false, // Default disableFirstRow to true
  }));

  const [rows, setRows] = useState(() => {
    const savedData = JSON.parse(localStorage.getItem(localStorageKey) || "[]");
    if (Array.isArray(savedData) && savedData.length > 0) {
      return savedData;
    }
    return [
      updatedColumns.reduce((acc, { key, defaultValue }) => {
        acc[key] = defaultValue || (key === "checkbox" ? false : "");
        return acc;
      }, {})
    ];
  });

  useEffect(() => {
    localStorage.setItem(localStorageKey, JSON.stringify(rows));
  }, [rows, localStorageKey]);

   const handleRowChange = (action, index = null, field = null, value = null) => {
    const updatedRows = [...rows]; // Make a copy of the current rows

    if (action === "remove" && index !== null) {
      updatedRows.splice(index, 1);
    } else if (action === "add") {
      updatedRows.splice(index + 1, 0, updatedColumns.reduce((acc, { key, defaultValue }) => {
        acc[key] = defaultValue || ""; // Add an empty row at the specified index
        return acc;
      }, {}));
    } else if (action === "update" && index !== null && field) {
      // Toggle the checkbox value
      if (field === "checkbox") {
        updatedRows[index][field] = !updatedRows[index][field]; // Toggle checkbox state
      } else {
        updatedRows[index][field] = value;  // Update other fields
      }
    }

    setRows([...updatedRows]);  // Update the state with the modified rows
    localStorage.setItem(localStorageKey, JSON.stringify(updatedRows));
    onTableDataChange([...updatedRows]);
  };
  

  const renderInputField = (type, value, onChange, options = [], disableFirstRow, trueLabel = "Yes", falseLabel = "No") => {
    switch (type) {
      case "date":
        return <input type="date" value={value} onChange={onChange} disabled={disableFirstRow} />;
      case "number":
        return <input type="number" value={value} onChange={onChange} disabled={disableFirstRow} />;
      case "dropdown":
        return (
          <select value={value} onChange={onChange} disabled={disableFirstRow}>
            <option value="">Select</option>
            {options.map((option, idx) => (
              <option key={idx} value={option}>{option}</option>
            ))}
          </select>
        );
        case "checkbox":
          return (
            <label className="checkbox-container">
            <input type="checkbox" checked={value} onChange={onChange} disabled={disableFirstRow} />
            <span>{value ? trueLabel : falseLabel}</span>
          </label>
        );
        
      default:
        return <input type="text" value={value} onChange={onChange} disabled={disableFirstRow} />;
    }
  };

  return (
    <div className="google_forms">
      <label>{tableName}</label>
      <table border="0">
        <thead>
          <tr>
            {updatedColumns.map((col) => <th key={col.key}>{col.header}</th>)}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx}>
              {updatedColumns.map((col) => (
                <td key={col.key}>
                  {renderInputField(
                    col.type,
                    row[col.key] || "",
                    e => handleRowChange("update", idx, col.key, e.target.type === "checkbox" ? e.target.checked : e.target.value),
                    col.options,
                    idx === 0 && updatedColumns.find(c => c.key === col.key)?.disableFirstRow // Disable first row based on the column definition
                  )}
                </td>
              ))}
              <td>
                <button
                  type="button"
                  onClick={() => handleRowChange("add", idx)}
                >
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => handleRowChange("remove", idx)}
                  disabled={idx === 0}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicTable2;
